import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "er-container wrapper m-y-8 information" }
const _hoisted_2 = { class: "m-y-8" }

import Spinner from '../components/atoms/Spinner.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('checkingAuth')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Spinner, { center: true })
    ])
  ]))
}
}

})